export const getMapPickerPosition = (
  value?: { coordinates?: number[] } | null,
): [number, number] | null => {
  const coordinates = value?.coordinates;
  return coordinates?.length === 2 && coordinates.every(Number.isFinite)
    ? [coordinates[1], coordinates[0]]
    : null;
};
